import styled from "@emotion/styled";
import { RadioTileGroup } from "common/components/ui";

export const FlexRadioTileGroup = styled(RadioTileGroup)`
  width: 100%;
  & label {
    flex-grow: 1;
  }
`;
